import { ComponentProps, useContext, useMemo } from 'react';
import { AppContext } from '../../contexts/AppContext';
import { buildMinisiteLink } from '../useMinisiteLink';
import Link from 'next/link';

export const useBookingLink = ({
    educatorSlug,
    courseSlug,
    occurrenceId,
    bookingId,
}: {
    educatorSlug: string;
    courseSlug: string;
    occurrenceId: string | null;
    bookingId?: string;
}): Pick<ComponentProps<typeof Link>, 'href' | 'target' | 'rel'> => {
    const query = useMemo(() => {
        if (!bookingId) {
            return '';
        }
        return `?booking=${bookingId}`;
    }, [bookingId]);
    const appContext = useContext(AppContext);
    const linkSegment: string = occurrenceId
        ? `/${courseSlug}/details/${occurrenceId}${query}`
        : `dates?booking=${bookingId}`;
    switch (appContext.context) {
        case 'marketplace': {
            return {
                href: `/${educatorSlug}${linkSegment}`,
            };
        }
        case 'minisite': {
            if (appContext.educatorSlug !== educatorSlug) {
                return {
                    target: '_blank',
                    rel: 'noopener noreferrer',
                    href: buildMinisiteLink(educatorSlug, `${linkSegment}`),
                };
            }
            return {
                href: `${linkSegment}`,
            };
        }
        case 'embed': {
            return {
                target: '_blank',
                rel: 'noopener noreferrer',
                href: buildMinisiteLink(educatorSlug, `${linkSegment}`),
            };
        }
    }
};
